<!--
 * @Description: 
 * @Author: xiaoq
 * @Date: 2024-06-13 16:04:03
 * @LastEditTime: 2024-09-14 11:22:36
 * @LastEditors: xiaoq
-->
<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1Box max-w-1400">
        <!-- <img :src="importedImg1" alt="" class="imgItem1" /> -->
        <span
          >Copyright © CANAAN GROUP TRADING SERVICE COMPANY LIMITED-CAFOOD
          BRANCH</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
// import importedImg1 from "@/page/canaanservice/components/img/footer.png";

export default {
  data() {
    return {
      // importedImg1: importedImg1,
      altText: "图片",
    };
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}

img {
  display: block;
}

.imgBox1,
.imgBox2,
.imgBox3,
.imgBox4,
.imgBox5,
.imgBox6 {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.img1Box,
.img2Box,
.img3Box,
.img4Box,
.img5Box,
.img6Box {
  width: 100%;
  overflow: hidden;
  background-color: "";
}

.imgItem1,
.imgItem2,
.imgItem3,
.imgItem4,
.imgItem5,
.imgItem6 {
  width: 100%;
  margin: auto;
}

.img1Box {
  height: 58px;
  flex-shrink: 0;
  background: #147074;
  display: flex;
  align-items: center;
  justify-content: center;
}
.img1Box span {
  color: #ffffff;
  font-family: "SF Pro Display";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px;
  opacity: 0.7;
}
</style>
